import { z } from "zod";

export const companyStatusSchema = z.enum(["ACTIVE", "LOCKED", "DELETE"]);

export const companyStatuses = companyStatusSchema.options;
export type CompanyStatus = z.infer<typeof companyStatusSchema>;
